import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';

export const getCustomerMembers = createAsyncThunk(
  'users/getCustomerMembers',
  async (customerId) => {
    const result = await api.users.getCustomerMembers({
      customerId,
    });

    return result.data.getCustomerMembers.users;
  }
);

export const removeCustomerMember = createAsyncThunk(
  'users/removeCustomerMember',
  async ({ userId, customerId }, { getState }) => {
    const result = await api.users.removeCustomerMember({
      userId,
      customerId,
    });

    // removedUserId/currentUserId let the roles slice tell self-removal (drop
    // the caller's own customer role) from removing another member (no change).
    return {
      ...result.data.removeCustomerMember,
      removedUserId: userId,
      currentUserId: getState().user?.id,
    };
  }
);

export const updateUserRoleByWorkspaceId = createAsyncThunk(
  'users/updateUserRoleByWorkspaceId',
  async ({ userId, workspaceId, roleId }) => {
    const result = await api.users.updateUserRoleByWorkspaceId({
      userId,
      workspaceId,
      roleId,
    });

    return result.data.updateUserRoleByWorkspace;
  }
);

export const updateUserRoleByCustomerId = createAsyncThunk(
  'users/updateUserRoleByCustomerId',
  async ({ userId, customerId, roleId }) => {
    const result = await api.users.updateUserRoleByCustomerId({
      userId,
      customerId,
      roleId,
    });

    return result.data.updateUserRoleByCustomerId;
  }
);

export const setCustomerMemberAll = createAsyncThunk(
  'users/setCustomerMemberAll',
  async ({ userId, customerId, roleId }) => {
    const result = await api.users.setCustomerMemberAll({
      userId,
      customerId,
      roleId,
    });

    return result.data.setCustomerMemberAll;
  }
);

export const setCustomerMemberDevices = createAsyncThunk(
  'users/setCustomerMemberDevices',
  async ({ userId, customerId, roleId, deviceIds }) => {
    const result = await api.users.setCustomerMemberDevices({
      userId,
      customerId,
      roleId,
      deviceIds,
    });

    return result.data.setCustomerMemberDevices;
  }
);
